import pinia from "@/plugins/pinia";
import { useMenuStateStore } from "@/store/menu-state";
import { useRequestDataStore } from "@/store/request-data";
import { useReportStore } from "@/store/report";
import { BaseMenuEntry } from "./base-menu-entry";

export class ValidationMenuEntry extends BaseMenuEntry
{
    protected menuStateStore = useMenuStateStore(pinia);
    protected requestDataStore = useRequestDataStore(pinia);
    protected reportStore = useReportStore(pinia);

    public getPicto() : string
    {
        return require("@/assets/pictos/menu-entries/08-validation.svg");
    }

    public isEnabled() : boolean
    {
        return this.requestDataStore.hasAdjustment;
    }

    public isValid() : boolean
    {
        return true; // Always valid (as soon as it is enabled)
    }

    public isValidated() : boolean
    {
        // Indirectly validated by the user when clicking the "Validate" button
        return this.reportStore.validationDate !== null;
    }

    public toggleValidation() : void
    {
        // Validation is controlled by the user, but only via the "Validate" button on the
        // validation page, thus validation by the menu icon is disabled.
        return;
    }
}
